import {State} from '../types'
import {getEvent} from './event'

export const getDatesInformation = (state: State) => {
  return state.dates.events[getEvent(state).id]
}
